import List from './list/LabResearchOrderStatusListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})